<template>
  <Teleport to="#app3Placeholder">
    <div id="appVue3">
      <component
        :is="isDesktop ? 'NavigationBar' : 'AppHeader'"
        v-if="showAppHeader"
      />
      <div class="app-content">
        <RejectedReason
          v-if="showRejectedReason"
          @handleCheckClick="handleRejectedReasonClick"
        />
        <router-view v-else-if="isAppConfigFetched" />
        <RegistrationStatusModal v-if="isRegistrationModalVisible" />
        <NpsModal
          v-if="isNPSPopupVisible"
          :show-modal="isNPSPopupVisible"
        />
        <AgreementModal
          v-if="isAgreementPopupVisible"
          :is-modal-visible="isAgreementPopupVisible"
        />
      </div>
      <TenantPicker
        v-if="showTenantPicker"
        :show-tenant-picker="showTenantPicker"
      />
      <NavigationBar v-if="showAppBottomNabBar" />
    </div>
  </Teleport>
</template>
<script src="./js/app.js" />
<style lang="scss" scoped>
html:not([dark]) {
  @import '@blibli/blue-design-tokens/dist/tokens-default.scss';
  @import './index.scss';
}

html[dark] {
  @import '@blibli/blue-design-tokens/dist/tokens-dark.scss';
  @import './index.scss';
}
</style>
